<!--
create by melody on 2018/11/1
description:操作界面-上传界面
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <div class="table-container" style="min-height:500px;">
            <p>
                <el-button type="text" icon="el-icon-arrow-left" @click="close">{{$t('m.back')}}</el-button>
            </p>
            <lap-upload-file :uploadUrl="uploadUrl" ></lap-upload-file>
        </div>
    </div>
</template>
<script>
export default {
    name: 'OprateUpload',
    props: ['paramsObj'], //调用组件传递过来的相关参数
    data () {
        return {
            title: {
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.OPERATE_MANAGE'),
                thirdTitle: this.paramsObj.fromPageName,
                fourTitle: this.$t('m.uploadPage')
            },
            isDisableUpLoadAction: true,
            uploadUrl: ''
        }
    },
    computed: {

    },
    methods: {
        close () {
          this.$emit('close')
        },
    },
    mounted() {
        console.log('upload type : %s', JSON.stringify(this.paramsObj.uploadType))
        if(this.paramsObj.uploadType == 'EPO') {
            this.uploadUrl = '/compute/upload/uploadedEPOFile'
        } else if(this.paramsObj.uploadType == 'staff') {
            this.uploadUrl = '/compute/upload/uploadedHandOperationFile'
        } else if (this.paramsObj.uploadType == 'YEPO') {
            this.uploadUrl = '/compute/upload/uploadedOriginalEPOFile' //元数据上传
        } else {
            this.uploadUrl = '/compute/upload/uploadPOFile';
        }
    }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/OprateUpload.vue